export default {"src":"/_next/static/media/mastercard-logo.c07d3b07.svg","height":618,"width":999,"blurWidth":0,"blurHeight":0};